import { FilterCommonTypes } from '../types-store';
import { CustomFilterType, FilterCommonValues, OptionType } from './types';

const externalFieldSerialization = {
  [CustomFilterType.externalValue]: (value: FilterCommonValues<string>[], notSpecifiedText: string) =>
    value?.[0]?.optionType === OptionType.notSpecified
      ? notSpecifiedText
      : value && value?.[0]?.value?.trim() || undefined
};

export const getExternalValue = (
  value: FilterCommonValues<FilterCommonTypes>[],
  type: CustomFilterType,
  notSpecifiedText: string
) => {
  const serialization = externalFieldSerialization[type];
  return serialization
    ? serialization(value, notSpecifiedText)
    : value;
};
